import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { PageService } from '@app/pages/services/page.service';
import { ThemeService } from '@app/shared/services/theme.service';

@Component({
  selector: 'app-latest-event',
  templateUrl: 'latest-event.component.html',
  styleUrls: ['./latest-event.component.scss']
})

export class LatestEventComponent implements OnInit {
  isLoading: boolean;
  cityParams: HttpParams;
  eventLimit = 15;
  pageLoad = 1;
  latestEventParams: HttpParams;
  latestEventData: any;
  defaultImage = 'assets/images/default-img.jpg';
  currentTheme: string;

  constructor(
    public themeService: ThemeService,
    private pageService: PageService,
    public router: Router,
  ) {
    this.themeService.themes.subscribe(theme => {
      this.currentTheme = theme;
    });
  }

  ngOnInit() {
    this.getEvents();
  }

  getEvents() {
    this.isLoading = true;
    this.latestEventParams = new HttpParams().append('limit', this.eventLimit);
    this.pageLoad = 1;
    this.pageService.getEventList(this.latestEventParams).subscribe(data => {
      this.isLoading = false;
      const upcomingEvents = data.results.filter(item => item.status === 'up_coming' || item.status ==='ongoing');
      if (upcomingEvents.length > 0) {
        this.latestEventData = upcomingEvents;
      } else {
        const pastEvents = data.results.filter(item => new Date(item.start_time) < new Date());
        if (pastEvents.length > 0) {
          const sortedPastEvents = pastEvents.sort((a, b) => new Date(b.start_time).getTime() - new Date(a.start_time).getTime());
          const lastPastEvent = sortedPastEvents[0];
          this.latestEventData = [lastPastEvent];
        } else {
          this.latestEventData = [];
        }
      }
    }, error => {
      console.error(error);
    });
  }

  onError(event: any) {
    event.target.src = this.defaultImage;
  }

  routClick(id: any) {
    this.router.navigate(['/events/', id]);
  }
}
